import React from 'react'
import { Box, Typography } from '@mui/material'
import { Home as HomeIcon, ChevronRight as ChevronRightIcon } from '@mui/icons-material'
import BackButton from './BackButton'
import { NAV_CHROME as N } from './navChrome'

/** EduOKGold content-header: solid colorPrimary bar, 40px, breadcrumbs + back */
const CONTENT_HEADER_BG = N.light // #F9A602

/**
 * EduOKWeb-style content-header: breadcrumbs/title (left), Back + actions (right).
 */
const PageContentHeader = ({
  title,
  subtitle,
  breadcrumbs,
  onBack,
  showBack = true,
  titleIcon,
  actions,
}) => {
  if (!title && !showBack && !breadcrumbs?.length) {
    return null
  }

  const crumbItems =
    breadcrumbs?.length > 0
      ? breadcrumbs
      : title
        ? [{ label: title, icon: titleIcon }]
        : []

  return (
    <Box
      component="header"
      className="page-content-header content-header"
      sx={{
        flexShrink: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 1,
        flexWrap: 'nowrap',
        height: 40,
        minHeight: 40,
        maxHeight: 40,
        px: 0,
        py: 0,
        backgroundColor: CONTENT_HEADER_BG,
        color: N.text,
        borderBottom: 'none',
        boxShadow: 'none',
        overflow: 'hidden',
      }}
    >
      <Box
        className="leftside-content-header"
        sx={{
          flex: 1,
          minWidth: 0,
          display: 'flex',
          alignItems: 'center',
          height: 40,
          pl: '20px',
        }}
      >
        {crumbItems.length > 0 && (
          <Box
            component="ul"
            className="breadcrumbs"
            sx={{
              listStyle: 'none',
              m: 0,
              p: 0,
              display: 'flex',
              alignItems: 'center',
              flexWrap: 'nowrap',
              gap: 0,
              lineHeight: '40px',
              minWidth: 0,
              overflow: 'hidden',
            }}
          >
            {crumbItems.map((crumb, index) => (
              <Box
                component="li"
                key={`${crumb.label}-${index}`}
                sx={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  fontSize: '0.9375rem',
                  fontWeight: 600,
                  verticalAlign: 'middle',
                  lineHeight: 1.35,
                  minWidth: 0,
                  color: N.text,
                }}
              >
                {index > 0 && (
                  <ChevronRightIcon
                    sx={{
                      fontSize: 16,
                      mx: 0.5,
                      color: N.yellow,
                      flexShrink: 0,
                    }}
                  />
                )}
                {index === 0 && (
                  <Box
                    component="span"
                    sx={{
                      display: 'inline-flex',
                      alignItems: 'center',
                      pr: 1,
                      color: N.text,
                      flexShrink: 0,
                      '& .MuiSvgIcon-root': { color: `${N.text} !important` },
                    }}
                  >
                    {crumb.icon ?? titleIcon ?? (
                      <HomeIcon sx={{ fontSize: 16, color: N.text }} />
                    )}
                  </Box>
                )}
                {index > 0 && crumb.icon && (
                  <Box
                    component="span"
                    sx={{
                      display: 'inline-flex',
                      pr: 0.75,
                      flexShrink: 0,
                      color: N.text,
                      '& .MuiSvgIcon-root': { color: `${N.text} !important` },
                    }}
                  >
                    {crumb.icon}
                  </Box>
                )}
                <Box
                  component="span"
                  className="breadcrumb-label"
                  sx={{
                    color: N.text,
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                    maxWidth: { xs: '55vw', md: 'none' },
                  }}
                >
                  {crumb.label}
                </Box>
              </Box>
            ))}
          </Box>
        )}
        {subtitle && (
          <Typography
            variant="body2"
            className="page-content-header-subtitle"
            sx={{
              display: { xs: 'none', lg: 'block' },
              color: 'rgba(25, 25, 25, 0.72) !important',
              ml: 1.5,
              fontSize: '0.75rem',
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            }}
          >
            {subtitle}
          </Typography>
        )}
      </Box>

      <Box
        className="rightside-content-header"
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 1,
          flexWrap: 'nowrap',
          flexShrink: 0,
          height: 40,
          pr: '20px',
          pl: 1,
        }}
      >
        {actions}
        {showBack && onBack && <BackButton onClick={onBack} />}
      </Box>
    </Box>
  )
}

export default PageContentHeader
